<template>
<div class="chapter">
<div class="inner_page">
<p style="font-weight: bold; page-break-before: always; text-align: center; text-indent: 0">DEDICATION</p>
<p class="section-break">––––––––</p><div class="decoration-scene-break"><div class="decoration-scene-break-inner"><img alt="image" class="decoration-scene-break" src="d2d_images/scene_break.png"/></div></div>
<p class="first-in-scene" style="text-align: justify"><span style="font-size: x-large"><span class="first-scene-phrase"><span class="first-in-scene character-t">T</span></span></span>his series is dedicated to all of the strong women who have had to face bullying, are facing bullying, and who have had to overcome it.  </p>
<p style="font-size: large; page-break-before: always; text-align: center; text-indent: 0">SERIES BLURB</p>
<p style="text-align: center; text-indent: 0">Tossing the Black Envelope is tradition. Now Tempest Ryan has received it, anyone in school can bully her. </p>
<p style="text-align: center; text-indent: 0">Make her leave. </p>
<p style="text-align: center; text-indent: 0">That's the K3's decree. That's what she gets for trying to mess with us Royals. </p>
<p style="text-align: center; text-indent: 0">Kingsbury Prep is a 500 year old institution. </p>
<p style="text-align: center; text-indent: 0">Only those with royal blood can attend this school. </p>
<p style="text-align: center; text-indent: 0">A commoner like Tempest Ryan does not belong. </p>
<p style="text-align: center; text-indent: 0">We will break her, break her will, break her heart. </p>
<p style="text-align: center; text-indent: 0">She will wish she never stepped foot into Kingsbury. </p>
<p style="text-align: center; text-indent: 0">Only now, she is getting under all of our skin like a burn that can't stop itching. </p>
<p class="section-break">––––––––</p><div class="decoration-scene-break"><div class="decoration-scene-break-inner"><img alt="image" class="decoration-scene-break" src="d2d_images/scene_break.png"/></div></div>
<p style="text-align: center; text-indent: 0">Kingsbury Prep's K3 Royals have made it known they don't want me here. </p>
<p style="text-align: center; text-indent: 0">Being at the receiving end of the notorious Black Envelope is no laughing matter. </p>
<p style="text-align: center; text-indent: 0">I'd learned someone had died from it. Another nearly died but left Kingsbury just in time. </p>
<p style="text-align: center; text-indent: 0">These guys are cruel. They started a war against me. Even though I am reeling from the pain, I have some secrets of my own. </p>
<p style="text-align: center; text-indent: 0">Love and Hate is a fine line, especially when they all seem to hate me, but can't stop wanting me. </p>
<p style="text-align: center; text-indent: 0">***FALLEN ROYALS is reverse harem/mature high school bully romance novel. This is book four of six in the series. Contains foul language and sexual scenes; any sex featured is consensual. </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c003.vue?0bd53d88